import {combine} from 'effector';

import {clearProductsGridCache, fetchProductsGrid} from 'api';
import {createGridListModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {SimplePaginationContent} from 'types/api';
import {ProductsGridRawRow} from 'types/products-grid';

const domain = rootDomain.createDomain('ProductsGridListDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchProductsGrid,
});

export const clearDataCacheFx = domain.createEffect({
    name: 'clearDataCacheFx',
    handler: clearProductsGridCache,
});

export const {
    Gate,
    pageNumber$,
    pageNumberChanged,
    pageIncremented,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    filtersSubmit,
    filtersReset,
    sortings$,
    sortingsChanged,
    sortingsReset,
    listStateChanged,
    showConfigBlock$,
    showConfigBlockChanged,
    stateReset,
} = createGridListModel({domain});

export const data$ = domain.createStore<SimplePaginationContent<ProductsGridRawRow> | null>(null);

export const searchChanged = domain.createEvent<string>();
export const search$ = domain.createStore<string>('').on(searchChanged, (_, value) => value);

export const listState$ = combine({
    data: data$,
    filters: filters$,
    sortings: sortings$,
    search: search$,
    pageIncremented,
    showConfigBlock: showConfigBlock$,
    isLoading: fetchDataFx.pending,
});
